import React, { Component, useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../../Components/MainLayout/Loader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MySnackbar from "../../../Components/MyComponents/MySnackbar";
import Authorize from "../../../../global/Authorize";
import Header from "../../../Components/MainLayout/Header";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

function NumberSms(props) {
  const [message, setMessage] = useState(null);
  const [smsNo, setSmsNo] = useState(null);
  const [successSnackBar, setSuccessSnackBar] = useState(false);
  const [errorSnackBar, setErrorSnackBar] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    const response = {
      message,
      number: smsNo,
      school: props.user.user.school.id,
    };
    axios
      .post("api/msendSMS", response)
      .then((res) => setSuccessSnackBar(true))
      .catch((err) => setErrorSnackBar(true));
  };

  useEffect(() => {
    setSuccessSnackBar(false);
    setErrorSnackBar(false);
  }, []);

  return (
    <Authorize
      roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
      redirect
      to="/login"
    >
      <Header to="/home" title="Number SMS" />
      <div className="container col-12 mt-3">
        <Link to="/smstemplate">
          <button className="th-btn-primary px-4 py-2 mb-4">
            SMS Template
          </button>
        </Link>
        <div className="th-18 th-fw-600 th-primary">PARTICULAR NUMBER SMS</div>
        <form action="">
          <div className="th-14 flex-column my-4">
            To Number
            <input
              className="ml-2"
              placeholder="98********"
              onChange={(e) => setSmsNo(e.target.value)}
            />
          </div>
          <div className="th-14 flex-column">
            Message
            <textarea
              className="form-control th-input-primary my-3"
              placeholder="Message"
              style={{ minHeight: 200 }}
              name="message"
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          <div className="d-flex justify-content-end py-3">
            {/* {this.state.loading ? (
            <div className="my-1 pr-2">
              <Loader />
            </div>
          ) : null} */}
            <button
              onClick={handleClick}
              type="submit"
              className="th-btn-primary px-4 py-2"
            >
              Send SMS
            </button>
          </div>
        </form>
      </div>
      {successSnackBar ? <MySnackbar title="Sms Sent Successfully" /> : null}
      {errorSnackBar ? (
        <MySnackbar title="Failed to send Successfully" />
      ) : null}
    </Authorize>
  );
}

export default withRouter(connect(mapStateToProps)(NumberSms));
